// Begleitnachricht für Einladungen per Link. Recruiter verschicken den Link
// selbst (Messenger, LinkedIn, ATS), die Nachricht spart das Tippen. Sie steht
// in der Sprache des Talents, nicht der Dashboard-Sprache, und kommt ohne du
// und Sie aus, weil Unternehmen ihre Talente unterschiedlich ansprechen.

import { formatAssessmentDeadline } from './assessment-deadline'

const I18N = 'components.career.invite_talent_modal.invite_message.'

// Das Dashboard ist nur auf de und en übersetzt, nl und fr bekommen en
const MESSAGE_LANGUAGES = ['de', 'en']

export const getInviteMessageLanguage = (language) => {
  const normalized = (language || '').toLowerCase()
  return MESSAGE_LANGUAGES.includes(normalized) ? normalized : 'en'
}

/**
 * @param {object} params
 * @param {Function} params.t i18n.getFixedT(getInviteMessageLanguage(...))
 * @param {string} params.language Sprache der Nachricht, für das Datum
 * @param {string} params.link Einladungslink
 * @param {string} [params.firstname]
 * @param {string} [params.careerTitle] ohne Stelle ist es der Talentpool
 * @param {string} [params.expiresAt] Space.expiresAt
 * @returns {string} Nachricht mit Leerzeilen zwischen den Absätzen
 */
export const buildInviteMessage = ({
  t,
  language,
  link,
  firstname,
  careerTitle,
  expiresAt
}) => {
  const deadline = formatAssessmentDeadline(expiresAt, language)

  return [
    firstname?.trim()
      ? t(I18N + 'greeting_with_name', { firstname: firstname.trim() })
      : t(I18N + 'greeting'),
    careerTitle
      ? t(I18N + 'intro_career', { career: careerTitle })
      : t(I18N + 'intro'),
    `${t(I18N + 'link')}\n${link}`,
    deadline && t(I18N + 'deadline', { date: deadline }),
    t(I18N + 'closing')
  ]
    .filter(Boolean)
    .join('\n\n')
}
